import React from 'react';

import { CategorySelector } from '@confluence/category-selector';
import { LoadingSortByDropdown } from '@confluence/template-utils';

import { LoadingTemplateListCards } from './LoadingTemplateListCards';
import { CategoriesWrapper, SortByWrapper } from './TemplateListStyles';

type LoadingTemplateListProps = {
	length?: number;
};

export const LoadingTemplateList = ({ length = 3 }: LoadingTemplateListProps) => {
	return (
		<div data-testid="template-list-loading">
			<CategoriesWrapper>
				<CategorySelector categories={[]} isLoading />
			</CategoriesWrapper>
			<SortByWrapper>
				<LoadingSortByDropdown />
			</SortByWrapper>
			<LoadingTemplateListCards length={length} />
		</div>
	);
};
